export function createObserver(target, callback) {
    const handler = {
        set: function (target, property, value) {
            if (value !== target[property]) {
                const oldValue = target[property];
                target[property] = value;

                callback(property, oldValue, value);
            }
            return true;
        },
    };

    return new Proxy(target, handler);
}
